import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import PriceListForm from './PriceList';

const GetCurrencyListQuery = gql`
  query {
    currencyList {
      id
      value
    }
  }
`;

interface IInputProps {
  children?: any;
  data: any;
}

interface IResponse {
  data: any;
}

export default compose(
  graphql<IInputProps, IResponse>(GetCurrencyListQuery, { 
    name: 'currencyList',
  }),
)(PriceListForm);


// WEBPACK FOOTER //
// ./src/components/PriceList/index.tsx